import { connect } from "react-redux";
import SamlAuthenticated from "../components/SamlAuthenticated/SamlAuthenticated";
import { samlAuthenticated } from "../redux/actions/SamlAuthenticated";

const mapStateToProps = () => {
  return {}
};

const mapDispatchToProps = (dispatch) => ({
  samlAuthenticated() {
    dispatch(samlAuthenticated());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SamlAuthenticated);



// WEBPACK FOOTER //
// ./src/containers/SamlAuthenticated.js